import { useMutation, useQuery } from '@tanstack/react-query'
import { addSubAdmin, updateSubAdmin, updateSubAdminStatus, deleteSubAdmin, getSubAdminList } from '../api/subAdmins'

// SubAdmins
export const useGetSubAdminsList = (queryParams = '') => {
    return useQuery({
        queryKey: ['sub_admins', queryParams],
        queryFn: () => getSubAdminList(queryParams),
        enabled: !!queryParams
    });
};

export const useAddSubAdmin = () => {
    return useMutation({
        mutationFn: addSubAdmin
    })
};

export const useUpdateSubAdmin = () => {
    return useMutation({
        mutationFn: updateSubAdmin
    })
};

export const useUpdateSubAdminStatus = () => {
    return useMutation({
        mutationFn: updateSubAdminStatus
    })
};

export const useDeleteSubAdmin = () => {
    return useMutation({
        mutationFn: deleteSubAdmin
    })
};